import produce from 'immer';
import { AnyAction } from 'redux';

import initialState from '../initialState/browser';
import * as browserActionTypes from '../../constants/actionTypes/browser';

const browser = (state = initialState, action: AnyAction) => produce(state, (draftState) => {
    switch (action.type) {
        case browserActionTypes.SET_BROWSER_NAME:
            draftState.browserName = action.payload;
            break;

        case browserActionTypes.SET_OS_NAME:
            draftState.OSName = action.payload;
            break;

        case browserActionTypes.SET_WINDOW_INNER_WIDTH:
            draftState.windowInnerWidth = +action.payload;
            break;

        case browserActionTypes.UPDATE_MODIFIER_KEY_PRESSED_STATUS:
            draftState.modifierKeyPressed = Boolean(action.payload);
            break;

        case browserActionTypes.UPDATE_LEFT_PANEL_COLLAPSED_STATUS:
            draftState.leftPanelCollapsed = Boolean(action.payload);
            break;

        case browserActionTypes.SET_APPLICATION_FOCUS:
            draftState.applicationFocus = action.payload;
            break;

        case browserActionTypes.APP_MODE_CHANGED:
            draftState.appMode = action.payload;
            break;

        default:
    }
});

export default browser;
